import { useEffect, useState } from "react";
import {
  Button,
  Box,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { UseSupplierOrder } from "../supplier-order/UseSupplierOrder";

export default function LastOrderDetail(props) {
  const { getOrderByID } = UseSupplierOrder();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [state, setState] = useState({
    productID: undefined,
    product: undefined,
    operator: undefined,
    product: undefined,
    productCount: undefined,
    requestCount: undefined,
    productURL: undefined,
    supplier: undefined,
    shamsiLogdate: undefined,
    shamsiWarehouseLogdate: undefined,
    warehouseOperator: undefined,
    stateTitle: undefined,
    description: undefined,
  });

  useEffect(() => {
    if (props.orderID) {
      setProgress(true);
      getOrderByID(props.orderID, (supplierRes) => {
        setState({
          id: supplierRes.id,
          productID: supplierRes.productID,
          operator: supplierRes.operator,
          product: supplierRes.product,
          productURL: supplierRes.productURL,
          warehouseOperator: supplierRes.warehouseOperator,
          productCount: supplierRes.productCount,
          requestCount: supplierRes.requestCount,
          supplier: supplierRes.supplier,
          shamsiLogdate: supplierRes.shamsiLogdate,
          shamsiWarehouseLogdate: supplierRes.shamsiWarehouseLogdate,
          stateTitle: supplierRes.stateTitle,
          description: supplierRes.description,
          warehouseDescription: supplierRes.warehouseDescription,
          warehouseOperator: supplierRes.warehouseOperator,
          shamsiVisitorLogdate: supplierRes.shamsiVisitorLogdate,
        });
      });
    }
  }, [props.orderID]);

  return (
    state && (
      <Grid container spacing={2}>
        <Grid item xs={4} sm={4} md={4}>
          <TextField
            value={state.supplier ? state.supplier : ""}
            label="تامین کننده"
            fullWidth
            id="profile-user-info-fullName-box"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              readOnly: true,
            }}
            variant="filled"
          />
        </Grid>
        <Grid item xs={4} sm={4} md={8}></Grid>
        <Grid item xs={4} sm={4} md={3}>
          <TextField
            value={state.productID ? state.productID : ""}
            label="کد محصول"
            fullWidth
            id="profile-user-info-fullName-box"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              readOnly: true,
            }}
            variant="filled"
            sx={{ input: { direction: "rtl" } }}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={9}>
          <TextField
            value={state.product ? state.product : ""}
            label="محصول"
            fullWidth
            id="profile-user-info-fullName-box"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              readOnly: true,
            }}
            variant="filled"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => window.open(state.productURL, "_blank")}
                    sx={{ mx: 1 }}
                  >
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          <TextField
            value={state.productCount ? state.productCount : ""}
            label="تعداد سفارش"
            fullWidth
            id="profile-user-info-fullName-box"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              readOnly: true,
            }}
            variant="filled"
            sx={{ input: { direction: "rtl" } }}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          <TextField
            value={state.operator ? state.operator : ""}
            label="اپراتور"
            fullWidth
            id="profile-user-info-fullName-box"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              readOnly: true,
            }}
            variant="filled"
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          <TextField
            value={state.warehouseOperator ? state.warehouseOperator : ""}
            label="انباردار"
            fullWidth
            id="profile-user-info-fullName-box"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              readOnly: true,
            }}
            variant="filled"
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          <TextField
            value={state.shamsiLogdate ? state.shamsiLogdate : ""}
            label="  درخواست"
            fullWidth
            id="profile-user-info-fullName-box"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              readOnly: true,
            }}
            variant="filled"
            sx={{ input: { direction: "rtl" } }}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          <TextField
            value={state.shamsiVisitorLogdate ? state.shamsiVisitorLogdate : ""}
            label="  بررسی"
            fullWidth
            id="profile-user-info-fullName-box"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              readOnly: true,
            }}
            variant="filled"
            sx={{ input: { direction: "rtl" } }}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          <TextField
            value={
              state.shamsiWarehouseLogdate ? state.shamsiWarehouseLogdate : ""
            }
            label="  تحویل انباردار"
            fullWidth
            id="profile-user-info-fullName-box"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              readOnly: true,
            }}
            variant="filled"
            sx={{ input: { direction: "rtl" } }}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          <TextField
            value={state.stateTitle ? state.stateTitle : ""}
            label="وضعیت"
            fullWidth
            id="profile-user-info-fullName-box"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              readOnly: true,
            }}
            variant="filled"
          />
        </Grid>
        <Grid item xs={4} sm={4} md={8}></Grid>
        <Grid item xs={4} sm={4} md={6}>
          <TextField
            value={state.description ? state.description : ""}
            label="توضیحات"
            fullWidth
            multiline
            rows={3}
            id="profile-user-info-fullName-box"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              readOnly: true,
            }}
            variant="filled"
          />
        </Grid>
        <Grid item xs={4} sm={4} md={6}>
          <TextField
            value={state.warehouseDescription ? state.warehouseDescription : ""}
            label="توضیحات انباردار"
            fullWidth
            multiline
            rows={3}
            id="profile-user-info-fullName-box"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              readOnly: true,
            }}
            variant="filled"
          />
        </Grid>
      </Grid>
    )
  );
}
